"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactPlacesAutocomplete = _interopRequireDefault(require("react-places-autocomplete")),
    _LocationSelectorResults = _interopRequireDefault(require("./LocationSelectorResults")),
    _LocationSelectorInput = _interopRequireDefault(require("./LocationSelectorInput")),
    _locationSelector = require("../styles/locationSelector");

function getSearchOptions() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = a.coords;
  return b ? {
    location: new google.maps.LatLng(b.latitude, b.longitude),
    radius: 2e3,
    types: ["address"]
  } : {};
}

function LocationSelector(a) {
  var b = a.addressString,
      c = a.onChangeAddress,
      d = a.onSelect,
      e = a.userLocation,
      f = a.placeholder,
      g = a.id,
      h = a.isManualEntry,
      i = a.disabled;
  return _react["default"].createElement(_reactPlacesAutocomplete["default"], {
    value: b,
    onChange: c,
    onSelect: d,
    searchOptions: getSearchOptions(e)
  }, function (a) {
    var b = a.getInputProps,
        c = a.suggestions,
        d = a.getSuggestionItemProps,
        e = a.loading;
    return _react["default"].createElement("div", {
      className: (0, _classnames["default"])(_locationSelector.LOCATION_SELECTOR, "location-selector")
    }, _react["default"].createElement(_LocationSelectorInput["default"], {
      getInputProps: b,
      loading: e,
      placeholder: f,
      id: g,
      isManualEntry: h,
      disabled: i
    }), _react["default"].createElement(_LocationSelectorResults["default"], {
      getResultProps: d,
      loading: e,
      suggestions: c
    }));
  });
}

var _default = (0, _react.memo)(LocationSelector);

exports["default"] = _default;